import { Button, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeRequestStateless } from '@utils/helpers';
import { getProfileCardByEmploymentIdReq } from '../requests';
import ViewEmployee from './ViewEmployee';
import './employee-profile.css';

const EmployeeProfilePage = ({ self = false, embedded = false }) => {
  const { employmentId } = useParams();
  const authUser = useSelector((state) => state.auth.authUser);
  const id = self ? authUser?.employment_id : employmentId;
  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const routeShowActive = location.state?.showActive;
  const profileShowActive = routeShowActive !== undefined
    ? routeShowActive
    : profile?.status
      ? profile.status === 'Active'
      : undefined;

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    makeRequestStateless(
      getProfileCardByEmploymentIdReq,
      routeShowActive !== undefined ? { id, showActive: routeShowActive } : { id },
      (response) => {
        setProfile(response.profile_card);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [id, routeShowActive]);

  const goBack = () => {
    debugger
    if (location.state?.from) navigate(location.state.from);
    else navigate(self ? '/' : '/employees/company');
  };

  return (
    <section className="employee-profile-page">
      { !embedded ? <header className="employee-profile-page__heading">
        <div>
          <h1>Employee Profile</h1>
          <p>{ self ? 'My Space' : 'People' } / <strong>{ profile?.full_name || 'Employee' }</strong></p>
        </div>
        <Button icon={ <ArrowLeftOutlined /> } onClick={ goBack }>
          Go Back
        </Button>
      </header> : null }

      <Spin spinning={ loading }>
        { id && profile?.employee_id ? (
          <ViewEmployee
            employment_id={ id }
            employee_id={ profile.employee_id }
            self={ self }
            presentation="page"
            showActive={ profileShowActive }
            onCompleted={ () => { } }
          />
        ) : null }
      </Spin>
    </section>
  );
};

export default EmployeeProfilePage;
